import styled from "@emotion/styled";

const ModalHeadline = styled.h3`
  margin: 16px 0 8px;
  font-size: 22px;
  font-weight: 800;
  text-align: center;
`;

export default ModalHeadline;
